import { render } from "./ReporteObservaciones01.vue?vue&type=template&id=0d48e6f4&scoped=true"
import script from "./ReporteObservaciones01.vue?vue&type=script&lang=js"
export * from "./ReporteObservaciones01.vue?vue&type=script&lang=js"

import "./ReporteObservaciones01.vue?vue&type=style&index=0&id=0d48e6f4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d48e6f4"]])

export default __exports__